import { useLayoutEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { markRouteRendered } from './reloadClassifier';

// Place inside Suspense and the auth Outlet: a URL change alone is not recovery.
export const ReloadRouteObserver = ({ children }: { children: ReactNode }) => {
  const { key } = useLocation();
  useLayoutEffect(() => { markRouteRendered(); }, [key]);
  return <>{children}</>;
};
